(function (app) {

    app.constant("employmentStatuses",
        [
            { ShortName: "Employed", LongName: "Employed" },
            { ShortName: "Retired", LongName: "Retired" },
            { ShortName: "Student", LongName: "Student" },
            { ShortName: "Unemployed", LongName: "Unemployed" },
            { ShortName: "BusinessOwner", LongName: "Business Owner" },
            { ShortName: "Disabled", LongName: "Disabled" },
            { ShortName: "RetiredPartTime", LongName: "Retired but Works Part Time"}
        ]);

})(window.app); //jshint ignore:line